import Filter from '@/library/filter/filter.interface';
import {FilterValue} from '@/library/filter/filter-value';

export class FilterEqual implements Filter {
    public name: string;
    public value: FilterValue;

    constructor(name: string, value: FilterValue) {
        this.name = name;
        this.value = value;
    }

    public query(): string {
        return this.name + '=' + this.value;
    }

    public object(): { value: FilterValue, not?: boolean } {
        return {value: this.value, not: false};
    }
}
